import React from "react";
import { Container, Row, Col } from "react-bootstrap";
import TrackVisibility from "react-on-screen";

export const Education = () => {
  return (
    <section className="education" id="education">
      <Container>
        <Row>
          <Col xs={12}>
            <h2 className="education-heading">Education & Research</h2>
          </Col>
        </Row>
        <Row className="g-4 mt-2">
          {/* Education Card */}
          <Col lg={6}>
            <TrackVisibility partialVisibility once>
              {({ isVisible }) => (
                <div className={`education-card ${isVisible ? "animate__animated animate__fadeInLeft" : ""}`}>
                  <div className="d-flex align-items-center mb-4">
                    <svg xmlns="http://www.w3.org/2000/svg" width="28" height="28" fill="#D4EDE4" viewBox="0 0 16 16" className="me-3">
                      <path d="M8.211 2.047a.5.5 0 0 0-.422 0l-7.5 3.5a.5.5 0 0 0 .025.917l7.5 3a.5.5 0 0 0 .372 0L14 7.14V13a1 1 0 0 0-1 1v2h3v-2a1 1 0 0 0-1-1V6.739l.686-.275a.5.5 0 0 0 .025-.917l-7.5-3.5Z"/>
                      <path d="M4.176 9.032a.5.5 0 0 0-.656.327l-.5 1.7a.5.5 0 0 0 .294.605l4.5 1.8a.5.5 0 0 0 .372 0l4.5-1.8a.5.5 0 0 0 .294-.605l-.5-1.7a.5.5 0 0 0-.656-.327L8 10.466 4.176 9.032Z"/>
                    </svg>
                    <h3 className="card-title m-0">Education</h3>
                  </div>
                  
                  <div className="education-item mb-4">
                    <h4 className="degree">BSc (Hons) in Information Technology – Software Engineering</h4>
                    <p className="institution">SLIIT, Malabe, Sri Lanka</p>
                    <span className="duration">Sep 2019 – Sep 2023</span>
                  </div>

                  <div className="education-item">
                    <h4 className="degree">G.C.E. Advanced Level — Physical Science Stream</h4>
                    <p className="institution">Ananda College, Colombo, Sri Lanka</p>
                    <span className="duration">2017</span>
                  </div>
                </div>
              )}
            </TrackVisibility>
          </Col>

          {/* IEEE Publication Card */}
          <Col lg={6}>
            <TrackVisibility partialVisibility once>
              {({ isVisible }) => (
                <div className={`ieee-card ${isVisible ? "animate__animated animate__fadeInRight" : ""}`}>
                  <div className="d-flex justify-content-between align-items-start mb-4">
                    <h3 className="card-title m-0">Research Publication</h3>
                    <span className="ieee-badge">IEEE Published</span>
                  </div>
                  
                  <h4 className="publication-title">LOOK AI — Intelligent Assistance System for Visually Impaired Users</h4>
                  <p className="conference">Conference: <strong>IEEE ICAIBD 2023</strong></p>
                  
                  <div className="tech-tags mb-3">
                    <span className="tech-pill">Flutter</span>
                    <span className="tech-pill">Machine Learning</span>
                  </div>

                  <div className="doi-container">
                    <span className="doi-label">DOI:</span>
                    <a href="https://doi.org/10.1109/ICAIBD57115.2023.10206191" target="_blank" rel="noopener noreferrer" className="doi-link">
                      10.1109/ICAIBD57115.2023.10206191
                      <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" fill="currentColor" className="bi bi-box-arrow-up-right ms-2" viewBox="0 0 16 16">
                        <path fillRule="evenodd" d="M8.636 3.5a.5.5 0 0 0-.5-.5H1.5A1.5 1.5 0 0 0 0 4.5v10A1.5 1.5 0 0 0 1.5 16h10a1.5 1.5 0 0 0 1.5-1.5V7.864a.5.5 0 0 0-1 0V14.5a.5.5 0 0 1-.5.5h-10a.5.5 0 0 1-.5-.5v-10a.5.5 0 0 1 .5-.5h6.636a.5.5 0 0 0 .5-.5z"/>
                        <path fillRule="evenodd" d="M16 .5a.5.5 0 0 0-.5-.5h-5a.5.5 0 0 0 0 1h3.793L6.146 9.146a.5.5 0 1 0 .708.708L15 1.707V5.5a.5.5 0 0 0 1 0v-5z"/>
                      </svg>
                    </a>
                  </div>
                </div>
              )}
            </TrackVisibility>
          </Col>
        </Row>
      </Container>
    </section>
  );
};
